var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    { attrs: { justify: "space-around" } },
    [
      _c("loading", { attrs: { loading: _vm.loading } }),
      _vm._v(" "),
      _c(
        "v-col",
        { attrs: { cols: "11" } },
        [
          _c(
            "v-stepper",
            {
              staticClass: "elevation-0",
              attrs: { "alt-labels": "", value: _vm.current }
            },
            [
              _c(
                "v-stepper-header",
                { staticClass: "elevation-0" },
                [
                  _c(
                    "v-stepper-step",
                    { attrs: { complete: _vm.current > 1, step: "1" } },
                    [
                      _c("span", { staticClass: "stepper-text" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.$t(
                                "view.contract_form.update.steps.office_info"
                              )
                            ) +
                            "\n                    "
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c(
                    "v-stepper-step",
                    { attrs: { complete: _vm.current > 2, step: "2" } },
                    [
                      _c("span", { staticClass: "stepper-text" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.$t(
                                "view.contract_form.update.steps.apply_info"
                              )
                            ) +
                            "\n                    "
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c(
                    "v-stepper-step",
                    { attrs: { complete: _vm.current > 3, step: "3" } },
                    [
                      _c("span", { staticClass: "stepper-text" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.$t(
                                "view.contract_form.update.steps.request_info"
                              )
                            ) +
                            "\n                    "
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  this.isEkyc
                    ? _c(
                        "v-stepper-step",
                        {
                          attrs: {
                            complete:
                              _vm.current > this.shippingAddressInfoStepNum,
                            step: this.shippingAddressInfoStepNum
                          }
                        },
                        [
                          _c("span", { staticClass: "stepper-text" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.$t(
                                    "view.contract_form.update.steps.shipping_address_info"
                                  )
                                ) +
                                "\n                    "
                            )
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  this.isEkyc ? _c("v-divider") : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-stepper-step",
                    {
                      attrs: {
                        complete: _vm.current > this.consentStepNum,
                        step: this.consentStepNum
                      }
                    },
                    [
                      _c("span", { staticClass: "stepper-text" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.$t("view.contract_form.update.steps.consent")
                            ) +
                            "\n                    "
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c(
                    "v-stepper-step",
                    {
                      attrs: {
                        complete: _vm.current > this.confirmStepNum,
                        step: this.confirmStepNum
                      }
                    },
                    [
                      _c("span", { staticClass: "stepper-text" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.$t("view.contract_form.update.steps.confirm")
                            ) +
                            "\n                    "
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c(
                    "v-stepper-step",
                    {
                      attrs: {
                        complete: _vm.current > this.completeStepnum,
                        step: this.completeStepnum
                      }
                    },
                    [
                      _c("span", { staticClass: "stepper-text" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.$t("view.contract_form.update.steps.complete")
                            ) +
                            "\n                    "
                        )
                      ])
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-stepper-items",
                [
                  _c("error-panel", {
                    ref: "errorPanel",
                    attrs: { error: _vm.hasError }
                  }),
                  _vm._v(" "),
                  _c(
                    "v-stepper-content",
                    { staticClass: "pt-2", attrs: { step: "1" } },
                    [
                      _c(
                        "v-row",
                        { staticClass: "pt-0 mt-0" },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                "label",
                                { staticClass: "font-weight-bold title " },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t(
                                          "view.contract_form.update.steps.office_info"
                                        )
                                      ) +
                                      "\n                            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              this.isEkyc
                                ? _c("div", {
                                    staticClass:
                                      "caption font-weight-bold red--text",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$t(
                                          "view.contract_form.update.messages.standard_plan_message"
                                        )
                                      )
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("v-divider")
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("office-info", {
                        ref: "officeInfo",
                        attrs: {
                          getMessage: this.getErrorMessage,
                          email: _vm.email
                        },
                        on: {
                          "submit-complete": _vm.onSubmit,
                          "error-occured": _vm.showError,
                          "error-fixed": _vm.hideError
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-stepper-content",
                    { staticClass: "pt-2", attrs: { step: "2" } },
                    [
                      _c(
                        "v-row",
                        { staticClass: "pt-0 mt-0" },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                "label",
                                { staticClass: "font-weight-bold title " },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t(
                                          "view.contract_form.update.steps.apply_info"
                                        )
                                      ) +
                                      "\n                            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("v-divider")
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("apply-info", {
                        ref: "applyInfo",
                        attrs: { getMessage: this.getErrorMessage },
                        on: {
                          "on-back": _vm.onBack,
                          "submit-complete": _vm.onSubmit,
                          "error-occured": _vm.showError,
                          "error-fixed": _vm.hideError
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-stepper-content",
                    { staticClass: "pt-2", attrs: { step: "3" } },
                    [
                      _c(
                        "v-row",
                        { staticClass: "pt-0 mt-0" },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                "label",
                                { staticClass: "font-weight-bold title " },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t(
                                          "view.contract_form.update.steps.request_info"
                                        )
                                      ) +
                                      "\n                            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm.isRequestInfoEditable()
                                ? _c("div", {
                                    staticClass: "caption font-weight-thin",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$t(
                                          "view.contract_form.update.messages.request_info_message"
                                        )
                                      )
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("v-divider")
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("request-info", {
                        ref: "requestInfo",
                        attrs: {
                          "form-data": _vm.contractDocument,
                          getMessage: this.getErrorMessage
                        },
                        on: {
                          "on-back": _vm.onBack,
                          "submit-complete": _vm.onSubmit,
                          "error-occured": _vm.showError,
                          "error-fixed": _vm.hideError
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-stepper-content",
                    {
                      staticClass: "pt-2",
                      attrs: { step: this.shippingAddressInfoStepNum }
                    },
                    [
                      _c(
                        "v-row",
                        { staticClass: "pt-0 mt-0" },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                "label",
                                { staticClass: "font-weight-bold title " },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t(
                                          "view.contract_form.update.steps.shipping_address_info"
                                        )
                                      ) +
                                      "\n                            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", {
                                staticClass:
                                  "caption font-weight-bold red--text",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$t(
                                      "view.contract_form.update.messages.shipping_address_info_message"
                                    )
                                  )
                                }
                              }),
                              _vm._v(" "),
                              _c("v-divider")
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("shipping-address-info", {
                        ref: "shippingAddressInfo",
                        attrs: { getMessage: this.getErrorMessage },
                        on: {
                          "on-back": _vm.onBack,
                          "submit-complete": _vm.onSubmit,
                          "error-occured": _vm.showError,
                          "error-fixed": _vm.hideError
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-stepper-content",
                    {
                      staticClass: "pt-2",
                      attrs: { step: this.consentStepNum }
                    },
                    [
                      _c(
                        "v-row",
                        { staticClass: "pt-0 mt-0" },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                "label",
                                { staticClass: "font-weight-bold title " },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t(
                                          "view.contract_form.update.steps.consent"
                                        )
                                      ) +
                                      "\n                            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("v-divider")
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("consent", {
                        attrs: {
                          "form-data": _vm.contractDocument,
                          getMessage: this.getErrorMessage
                        },
                        on: {
                          "on-back": _vm.onBack,
                          "submit-complete": _vm.onSubmit,
                          "error-occured": _vm.showError,
                          "error-fixed": _vm.hideError
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-stepper-content",
                    {
                      staticClass: "pt-2",
                      attrs: { step: this.confirmStepNum }
                    },
                    [
                      _c(
                        "v-row",
                        { staticClass: "pt-0 mt-0" },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                "label",
                                { staticClass: "font-weight-bold title " },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t(
                                          "view.contract_form.update.steps.confirm"
                                        )
                                      ) +
                                      "\n                            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "caption font-weight-thin" },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t(
                                          "view.contract_form.update.messages.confirm_alert"
                                        )
                                      ) +
                                      "\n                            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("v-divider")
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("confirm", {
                        attrs: { "form-data": _vm.contractDocument },
                        on: {
                          "on-back": _vm.onBack,
                          "submit-complete": _vm.submitComplete
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-stepper-content",
                    {
                      staticClass: "pt-2",
                      attrs: { step: this.completeStepnum }
                    },
                    [_c("complete", { attrs: { email: _vm.email } })],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e04c8562", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e04c8562","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/contract_form/UpdateForm.vue
// module id = null
// module chunks = 